import React from 'react'
import ProductImage from './index'

export const HaulerProductImage = () => {
  return <ProductImage imageSource="/assets/img/app-logo/hauler.png" color="#1ab394" />
}
